import React from 'react';

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path d="M12.31,10l7.21-7.21A1.63,1.63,0,1,0,17.21.48L10,7.69,2.79.48A1.63,1.63,0,0,0,.48,2.79L7.69,10,.48,17.21a1.63,1.63,0,0,0,0,2.31A1.61,1.61,0,0,0,1.63,20a1.64,1.64,0,0,0,1.16-.48L10,12.31l7.21,7.21a1.64,1.64,0,0,0,1.16.48,1.61,1.61,0,0,0,1.15-.48,1.63,1.63,0,0,0,0-2.31Z" />
  </svg>
);

export default CloseIcon;
